import { LANGUAGES } from "@/constants/util.constants";
import { Label } from "@/shadcn/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcn/components/ui/select";
import React from "react";

type PreferredLanguageDropdownProps = {
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
  error: string | undefined;
};

const PreferredLanguageDropdown: React.FC<PreferredLanguageDropdownProps> = ({
  selectedLanguage,
  onLanguageChange,
  error,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="preferredLanguage">
        Preferred Language <span className="text-red-500">*</span>
      </Label>
      <Select
        value={selectedLanguage}
        onValueChange={(value: string) => onLanguageChange(value)}
      >
        <SelectTrigger className="w-full max-w-full truncate">
          <SelectValue placeholder="Select language" />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <div className="text-sm text-red-500">{error}</div>}
    </div>
  );
};

export default PreferredLanguageDropdown;
